import {createCrudSlice} from "../genericCrudSlice";
import {getWalletApi} from "../../api/entities/wallets";


const walletsCrudSlice = createCrudSlice('wallets', 'Edit Wallet', 'New Wallet', getWalletApi);
export const {openModalForEdit} = walletsCrudSlice;
export const {reset, openModalForCreate, closeModal, setItem} = walletsCrudSlice.actions;
export default walletsCrudSlice.reducer;